import { createRoot, getOwner, runWithOwner, type Owner } from "solid-js"
import type { Object3D } from "three"
import { addGameObject3DEventListener, type GameObject3DEventMap } from "../../event/GameObject3D/GameObject3DEvent"

export default function runWithObject3DOwner(
  obj: Object3D,
  fn: () => void
): void {
  const owner : Owner = obj.userData.owner ||= createRoot((dispose) => {
    addGameObject3DEventListener(obj as Object3D<GameObject3DEventMap>, 'dispose', dispose)
    return getOwner()
  })

  runWithOwner(owner, fn)
}